import { computed, ref, onMounted, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import httpRequest from '@/request/index';
import { showToast, showLoadingToast, showFailToast, closeToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const goods = ref({});
    const addCart = (id, no) => {
      store.dispatch("addCart", {
        id: id,
        count: no
      });
    };
    const editCart = value => {
      store.dispatch("editCart", {
        id: goods.value.id,
        count: value
      });
    };
    const delCart = (id, no) => {
      if (cartList.value[goods.value.id].count < no) {
        store.dispatch("editCart", {
          id: goods.value.id,
          count: 0
        });
      }
    };
    let cartList = computed(() => {
      return store.state.cartItem;
    });
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      let goodsId = router.currentRoute.value.query.id;
      if (goodsId > 0) {
        showLoadingToast({
          message: '加载中',
          forbidClick: true
        });
        httpRequest({
          method: "get",
          url: "?file=goods&act=show&id=" + goodsId
        }).then(res => {
          closeToast();
          if (res.state == 1) {
            goods.value = res.info;
          } else {
            showFailToast(res.msg);
          }
        });
      } else {
        showToast({
          message: "参数错误",
          onClose: function () {
            router.go(-1);
          }
        });
      }
    });
    onBeforeMount(() => {
      document.getElementsByTagName("body")[0].className = "bg_body";
    });
    onBeforeUnmount(() => {
      document.body.removeAttribute("class", "bg_body");
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      cartList,
      goods,
      addCart,
      editCart,
      delCart,
      goBack
    };
  }
};